import React, {useEffect, useState} from 'react';
// import ProductGallerySlide from './ProductGallerySlide';
// import ProductGallerySlideVideo from './ProductGallerySlideVideo';
import ProductGalleryStore from './flux/ProductGalleryStore';
import useKeyPress from './hooks/useKeyPress';
import Image from './Image';
import Video from './Video';
import VideoExternal from './VideoExternal';

export default function ProductGalleryModal() {
  const mediaArray = ProductGalleryStore.getMediaArray();
  const [mediaID, setMediaID] = useState(ProductGalleryStore.getModalMediaID());
  const [currentMedia, setCurrentMedia] = useState(false);
  // const [navigation, setNavigation] = useState(false);
  const [modalToggle, setModalToggle] = useState(false);
  const escapeKey = useKeyPress("Escape");
  const arrowRight = useKeyPress("ArrowRight");
  const arrowLeft = useKeyPress("ArrowLeft");

  useEffect(() => {
    const emitter1 = ProductGalleryStore.addListener('modalID', () => {
      const currentMediaID = ProductGalleryStore.getModalMediaID();
      currentMediaID ? setModalToggle(true) : setModalToggle(false);
      findCurrentMedia(currentMediaID);
    });
    return () => { emitter1.remove(); }
  });

  useEffect(() => {
    if (escapeKey) {
      console.log('pressed escape for modal.');
      closeModal();
    }
  }, [escapeKey]);

  useEffect(() => {
    if (arrowRight && currentMedia.nav) {
      ProductGalleryStore.setModalMediaID(currentMedia.nav.next);
    }
    if (arrowLeft && currentMedia.nav) {
      ProductGalleryStore.setModalMediaID(currentMedia.nav.previous);
    }
  }, [arrowRight, arrowLeft]);

  function findCurrentMedia(currentMediaID) {
    // console.log(currentMediaID);
    mediaArray.forEach(item => {
      if(item.id === currentMediaID) {
        setCurrentMedia(item);
      }
    });
    setMediaID(currentMediaID);
  }

  function closeModal() {
    ProductGalleryStore.setModalMediaID(false);
  }

  // function renderThumbnails(media) {
  //   return (
  //     <li>
  //       {/* <img src={media.} */}
  //       <button onClick={(() => { ProductGalleryStore.setModalMediaID(media.id) })}>
  //         {media.modalCount} of {mediaArray.length} {media.media_type}
  //         {media.id === mediaID ? ' - SELECTED': ''}
  //       </button>
  //     </li>
  //   )
  // }

  function renderNavArrowButton(id, name) {
    return (
      <button
        className={name} 
        onClick={(() => {
          ProductGalleryStore.setModalMediaID(id);
        })}
      >
        <span className="hidden">{name}</span>
        <i className={name === 'next' ? "fa-solid fa-angle-right" : "fa-solid fa-angle-left"} />
      </button>
    )
  }

  function renderStatus() {
    console.log(currentMedia.nav);
    return (
      <p className='count'>{currentMedia.nav.count} of {currentMedia.nav.total}</p>
    );
  }

  function renderModal() {
    // console.log(currentMedia);
    return (
      <div 
        className="product-media-gallery-modal-bg"
        onClick={((e) => { 
          if(e.target.className === 'product-media-gallery-modal-bg') {
            closeModal();
          } 
        })}
      >
        <div className="modal">
          <span className="modal-media">
            {/* <img className="temp-img" src={currentMedia.preview_image.src} /> */}
            {currentMedia.media_type === 'image' ? <Image media={currentMedia} /> : false}
            {currentMedia.media_type === 'video' ? <Video media={currentMedia} /> : false}
            {currentMedia.media_type === 'external_video' ? <VideoExternal media={currentMedia} /> : false}
          </span>
          <button className="close" onClick={(() => { closeModal() })}>
            <span class="hidden">Close Image Gallery</span>
            <i className="fa-solid fa-xmark" />
          </button>
          {currentMedia.nav ? renderNavArrowButton(currentMedia.nav.previous, 'previous') : ''}
          {currentMedia.nav ? renderNavArrowButton(currentMedia.nav.next, 'next') : ''}
          {currentMedia.nav ? renderStatus() : ''}
        </div>
        
        {/* <ul>
          {mediaArray.map((media) => {
            return renderThumbnails(media);
          })}
        </ul>
        {mediaArray.length}
        <button className="close" onClick={(() => { closeModal() })}>
          CLOSE BUTTON.
        </button> */}
      </div>
    )
  }

  return modalToggle ? renderModal() : false;
}